import { rem } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import {
  changeLineAlignment,
  changeVariation,
  getSelectedVariation,
  getTileShape,
} from "../../../../../../lib/redux/slices/dimensions-slice";
import { useDispatch, useSelector } from "react-redux";
import { useUpdateCart } from "../../../../../../hooks/use-update-cart";

const Variations = ({ data }) => {
  const dispatch = useDispatch();
  const selectedVariation = useSelector(getSelectedVariation);
  const currentShape = useSelector(getTileShape);
  const { updateCart } = useUpdateCart();

  const setLineAlignment = (data) => {
    dispatch(changeLineAlignment(data));
  };

  const setVariation = (item) => {
    updateCart((storeData) => ({
      ...storeData,
      dimensions: {
        ...storeData.dimensions,
        selectedVariation: item,
      },
    }));
    dispatch(changeVariation(item));
  };

  if (!data) return void 0;

  const strAscending =
    currentShape === "simple"
      ? [...data].sort((a, b) => (a.name > b.name ? 1 : -1))
      : data;

  return (
    <Layout className="builder-element">
      <div className="element">
        {/* <h5>Variations</h5> */}
        <h5>Variationer</h5>

        <div className="variations options-list">
          {strAscending.map((item, i) => {
            return (
              <label className="radioField options" key={i} data-selected={selectedVariation?.type === item.type}>
                  <input
                    type="radio"
                    value={item.type}
                    name={item.ptype}
                    checked={selectedVariation?.type === item.type}
                    onChange={(e) => {
                      setLineAlignment(e.target.value);
                      setVariation(item);
                    }}
                    hidden
                  />
                  {/* <span className="checkbox" /> */}
                  <div className="image">
                    <img
                      src={item.image}
                      alt={item.name}
                      // width={104}
                      // height={80}
                    />
                  </div>
                  {item.name}
                </label>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};
export default Variations;

const Layout = styled.div`
  ${({ theme }) => css`
    .element {
      h5 {
        margin-bottom: ${rem(15)};
        font-size: 14px;
        font-weight: bold;
      }

      .image {
        img {
          max-width: 60%;
        }
      }

      .options-list{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;

        .options{
          padding: 20px 10px;
          border-radius: 30px;
          background-color:  ${theme.colors.white};
          text-align: center;
          color: ${theme.colors.black};
          transition: 0.3s ease all;
          margin:0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          cursor: pointer;

          &[data-selected="true"] {
            background-color:${theme.colors.primary};
            color: ${theme.colors.white}
          }

        }
      }

      .variationss {
        .radioField {
          input {
            display: none;
            &:checked {
              + .checkbox {
                background-color: ${theme.colors.primary};
                border-color: ${theme.colors.primary};
              }
            }
          }
          label {
            display: flex;
            align-items: center;
            font-size: ${rem(13)};

            .checkbox {
              width: 100%;
              height: 20px;
              border: 1px solid ${theme.colors.gray["300"]};
              background-color: transparent;
              transition: 0.3s ease all;
              display: inline-block;
              flex: 0 0 35px;
              max-width: 35px;
              margin-right: ${rem(15)};
            }

            .image {
              flex: 0 0 44px;
              max-width: 44px;
              margin-right: ${rem(15)};

              img {
                vertical-align: middle;
              }
            }
          }

          + .radioField {
            margin-top: ${rem(15)};
          }
        }
      }
    }
  `}
`;
